import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { globals } from '@app/config/globals';

@Component({
  selector: 'form-group-terms',
  templateUrl: './form-group-terms.component.html',
  styleUrls: ['./form-group-terms.component.css']
})
export class FormGroupTermsComponent {

 
  @Input() control: UntypedFormControl;
  @Input() id: string = '';
  @Input() path: string = '';

 
  constructor() { }


}
